import dispatcher from 'dispatcher';
import Api from 'utils/api';
import * as actionConstants from 'utils/ActionConstants';
import axios from 'axios';

export const resetPassword = async form => {
    try {
        dispatcher.dispatch({ type: actionConstants.RESET_PASSWORD });
        const resp = await Api.resetPassword(form);
        dispatcher.dispatch({
            type: actionConstants.RESET_PASSWORD_SUCCESS,
            payload: resp
        });
    } catch (error) {
        dispatcher.dispatch({
            type: actionConstants.RESET_PASSWORD_FAILURE,
            payload: error
        });
    }
};



// WEBPACK FOOTER //
// ./src/modules/onboarding/pages/reset-password/ResetPasswordActions.js